export default __webpack_public_path__ + "static/media/frame20x30-wood-rotated.33e34605.jpg";